import StepThree from "@/components/dashboard/depositMoney/StepThree";

export default function DepositMoneyStepThree() {
  return <StepThree />;
}
